<template>
    <div v-if="offer">

        <vs-alert v-if="offer" :active="JSON.stringify(offer) !== rawOffer" class="mb-3" color="warning"> {{$t("UnsavedChanges")}}! </vs-alert>

        <vx-card v-if="offer" :title="$t('Description')" style="min-height: 200px" class="mb-6">
            <div class="vx-row">
                <div class="vx-col xl:w-4/12 w-full mb-6" id="page-user-view">
                    <h4 class="mb-3">{{$t('Data')}}</h4>
                    <table>
                        <tr>
                            <td class="font-semibold">{{$t("Name")}}</td>
                            <td class="w-full"><p style="cursor: pointer" v-if="!nameEditOpen" @click="nameEditOpen=true">{{ offer.name }}</p>
                                <vx-input-group v-else class="mb-base w-full mb-3">
                                    <vs-input v-model="offer.name" />

                                    <template slot="append">
                                        <div class="append-text btn-addon">
                                            <vs-button icon-pack="feather" icon="icon-check" color="primary" @click="nameEditOpen=false"/>
                                        </div>
                                    </template>
                                </vx-input-group>
                            </td>

                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("Client")}}</td>
                            <td>{{ $store.getters.companyClients[offer.client_company_id].name }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("User")}}</td>
                            <td>{{ $store.getters.companyUsers[offer.offer_management_user].name }}</td>
                        </tr>
                    </table>
                </div>
                <div class="vx-col xl:w-2/3 w-full">
                    <h4 class="mb-3">{{$t('Description')}}</h4>
                    <quill-editor v-if="offer" :disabled="this.$store.getters.userData.id !== offer.offer_management_user || offer.status > 1" v-model="offer.description"></quill-editor>
                </div>

            </div>
            <vs-button v-if="!(this.$store.getters.userData.id !== offer.offer_management_user || offer.status > 1)" type="border" @click="saveOffer" class="mr-3">{{$t('Save')}}</vs-button>
            <vs-button class="mr-3" v-if="this.$store.getters.userData.id === offer.offer_management_user && offer.status < 2" type="border" color="success" @click="moveOfferToNextStage(2)">{{$t('OffersReadyForMaking')}}</vs-button>
            <vs-button class="mr-3" v-if="$checkPermission(1903) && offer.status === 2" type="border" color="success" @click="moveOfferToNextStage(3)">{{$t('TakeOffer')}}</vs-button>
            <vs-button class="mr-3" v-if="this.$store.getters.userData.id === offer.commercial_user && offer.status === 3" type="border" color="success" @click="moveOfferToNextStage(4)">{{$t('OffersInWork')}}</vs-button>
            <vs-button class="mr-3" v-if="this.$store.getters.userData.id === offer.commercial_user && offer.status === 4" type="border" color="success" @click="selectOfferTypePrompt = true">{{$t('OffersOfferMade')}}</vs-button>
            <vs-button class="mr-3" v-if="this.$store.getters.userData.id === offer.offer_management_user && offer.status === 5" type="border" color="success" @click="moveOfferToNextStage(6)">{{$t('OffersSentToClient')}}</vs-button>
            <vs-button class="mr-3" v-if="this.$store.getters.userData.id === offer.offer_management_user && offer.status === 6" type="border" color="success" @click="moveOfferToNextStage(7)">{{$t('OffersApproved')}}</vs-button>
            <vs-button class="mr-3" v-if="this.$store.getters.userData.id === offer.offer_management_user && offer.status === 6" type="border" color="success" @click="moveOfferToNextStage(1)">{{$t('OffersChangeNeeded')}}</vs-button>
            <vs-button class="mr-3" v-if="this.$store.getters.userData.id === offer.commercial_user && offer.status === 7" type="border" color="success" @click="moveOfferToNextStage(8)">{{$t('OffersOrdered')}}</vs-button>
            <vs-button class="mr-3" v-if="this.$store.getters.userData.id === offer.offer_management_user && offer.status === 8" type="border" color="success" @click="moveOfferToNextStage(9)">{{$t('FinishOffer')}}</vs-button>
            <vs-button class="mr-3" v-if="this.$store.getters.userData.id === offer.offer_management_user && offer.status < 9" type="border" color="danger" @click="moveOfferToNextStage(10)">{{$t('CancelOffer')}}</vs-button>
            <vs-button class="mr-3" v-if="this.$store.getters.userData.id === offer.commercial_user && (offer.status === 3 || offer.status === 4 || offer.status === 7)" type="border" color="success" @click="moveOfferToNextStage(11)">{{$t('OffersChangeNeeded')}}</vs-button>
            <vs-button class="mr-3" v-if="this.$store.getters.userData.id === offer.offer_management_user && offer.status === 10" type="border" color="success" @click="moveOfferToNextStage(0)">{{$t('AddBackToOffers')}}</vs-button>
            <vs-button v-if="this.$checkPermission(205)" class="mt-5" color="warning" icon-pack="feather" icon="icon-save" type="border" @click="saveOfferAsTemplatePrompt = true" >{{$t("SaveAsTemplate")}}</vs-button>
        </vx-card>

        <div class="vx-row">
            <div class="vx-col xl:w-1/2 lg:w-1/2 w-full mb-6">
                <offer-files-table v-if="offer" :type="0" :id="Number($route.params.id)" :offer-user="offer.offer_management_user === this.$store.getters.userData.id" :commercial-user="offer.commercial_user === this.$store.getters.userData.id" :status="offer.status"/>
            </div>

            <div class="vx-col xl:w-1/2 lg:w-1/2 w-full mb-6">
                <offer-files-table v-if="offer" :type="1" :id="Number($route.params.id)" :offer-user="offer.offer_management_user === this.$store.getters.userData.id" :commercial-user="offer.commercial_user === this.$store.getters.userData.id" :status="offer.status"/>
            </div>

        </div>


        <div class="vx-row" v-if="offer">
            <div class="vx-col xl:w-9/12 w-full">
                <div class="vx-row w-full">
                    <div class="vx-col w-full mb-6">
                        <offer-material-table v-if="offer" :id="Number($route.params.id)" :offer-user="offer.offer_management_user === this.$store.getters.userData.id" :status="offer.status" :client-company-id="offer.client_company_id"/>
                    </div>
                    <div class="vx-col w-full mb-6">
                        <offer-tasks-table class="mb-6" v-if="offer" :id="Number($route.params.id)" :offer-user="offer.offer_management_user === this.$store.getters.userData.id" :status="offer.status" :client-company-id="offer.client_company_id"/>
                    </div>
                    <div class="vx-col w-full mb-6"  v-if="offer.commercial_notes.length > 0 || offer.commercial_user === this.$store.getters.userData.id">
                        <vx-card :title="$t('OfferCommercialNotes')">
                            <vs-button v-if="offer.commercial_notes.length === 0 && !commercialNoteEditingActive && offer.commercial_user === this.$store.getters.userData.id" type="border" @click="commercialNoteEditingActive = true" class="mb-3">{{$t('AddOfferCommercialNotes')}}</vs-button>
                            <vs-button v-if="commercialNoteEditingActive" type="border" @click="saveCommercialNotes" class="mb-3">{{$t('Save')}}</vs-button>
                            <p v-if="!commercialNoteEditingActive" @click="(!commercialNoteEditingActive && offer.commercial_user === $store.getters.userData.id) ? commercialNoteEditingActive = true : commercialNoteEditingActive = true" style="white-space: pre-wrap; cursor: pointer">{{offer.commercial_notes}}</p>
                            <vs-textarea v-if="commercialNoteEditingActive" class="w-full" v-model="offer.commercial_notes"></vs-textarea>
                        </vx-card>
                    </div>
                </div>
            </div>
            <div class="vx-col xl:w-3/12 w-full">
                <div class="vx-col w-full">
                    <vx-card :title="$t('OfferTimeline')">
                        <vx-timeline :data="timelineData" />
                    </vx-card>
                </div>
            </div>
        </div>


        <vs-popup :title="$t('OffersOfferMade')" :active.sync="selectOfferTypePrompt" style="z-index: 54000">
            <div>
                <p class="mt-6 mb-6">{{$t("OfferType")}}</p>
                <div class="flex flex-wrap items-center mt-2">
                    <ul style="display: flex; flex-wrap: wrap; justify-content: flex-start; align-items: center;">
                        <li class="mr-4" >
                            <vs-radio :vs-name="'project'" v-model="selectedOfferType" :vs-value="0" class="mr-6">{{$t("Project")}}</vs-radio>
                            <vs-radio :vs-name="'normal'" v-model="selectedOfferType" :vs-value="1">{{$t("OfferNormal")}}</vs-radio>
                        </li>
                    </ul>
                </div>
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="moveOfferToNextStage(5)">{{$t("Save")}}</vs-button>
            </div>
        </vs-popup>

        <vs-popup :title="$t('Save')" :active.sync="saveOfferAsTemplatePrompt">
            <div>
                <p class="mt-6">{{$t("Title")}}</p>
                <vs-input v-model="saveAsTemplateTitle" style="width: 100%"/>
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="saveAsTemplate">{{$t("Save")}}</vs-button>
            </div>
        </vs-popup>
    </div>
</template>
<script>

    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'

    import { quillEditor } from 'vue-quill-editor'
    import OfferFilesTable from "./OfferFilesTable";
    import OfferMaterialTable from "./OfferMaterialTable";
    import OfferTasksTable from "./OfferTasksTable";

    import VxTimeline from "@/components/timeline/VxTimeline"

    export default {
        components: {
            OfferTasksTable,
            OfferMaterialTable,
            OfferFilesTable,
            quillEditor,
            VxTimeline
        },
        data(){
            return {

                offer: null,
                rawOffer: null,

                nameEditOpen: false,

                commercialNoteEditingActive: false,

                selectedOfferType: 0,
                selectOfferTypePrompt: false,

                saveOfferAsTemplatePrompt: false,

                saveAsTemplateTitle: '',

            }
        },
        computed: {
          timelineData(){

              if(!this.offer) return [];

              let data = [];

              let lastStartChangeRequested = false;

              let startTime = this.moment(this.offer.date_added);
              if(this.offer.changes.hasOwnProperty(0)) {
                  startTime = this.moment(this.offer.changes[0]);
              }

              if(this.offer.changes.hasOwnProperty(1) && this.moment(this.offer.changes[1]).isAfter(startTime)) {
                  startTime = this.moment(this.offer.changes[1]);
                  lastStartChangeRequested = true
              }

              if(!lastStartChangeRequested) {

                  let currentColor = "success";
                  if(this.offer.status === 0){
                      currentColor= 'warning';
                  }

                  data.push({
                      color: currentColor,
                      icon: "PlusIcon",
                      title: this.$t("OfferTimelineShort0"),
                      desc: this.$t("OfferTimelineLong0"),
                      time: startTime.format('DD/MM/YYYY HH:mm')
                  });
              }else{

                  let currentColor = "danger";
                  if(this.offer.status === 1){
                      currentColor= 'warning';
                  }

                  data.push({
                      color: currentColor,
                      icon: "XCircleIcon",
                      title: this.$t("OfferTimelineShort1"),
                      desc: this.$t("OfferTimelineLong1"),
                      time: startTime.format('DD/MM/YYYY HH:mm')
                  });
              }



              let iconsAndStatuses = {
                  2: {
                      color: "success",
                      icon: "ArrowUpIcon",
                  },
                  3: {
                      color: "success",
                      icon: "ChevronDownIcon",
                  },
                  4: {
                      color: "success",
                      icon: "PlayIcon",
                  },
                  5: {
                      color: "success",
                      icon: "CheckIcon",
                  },
                  6: {
                      color: "success",
                      icon: "MailIcon",
                  },
                  7: {
                      color: "success",
                      icon: "CheckCircleIcon",
                  },
                  8: {
                      color: "success",
                      icon: "TruckIcon",
                  },
                  9: {
                      color: "success",
                      icon: "ArchiveIcon",
                  },
                  10: {
                      color: "danger",
                      icon: "XIcon",
                  }
              };

              for(let x = 2; x < 11; x++){

                  if(this.offer.changes.hasOwnProperty(x) && x <= this.offer.status) {

                      let color = iconsAndStatuses[x].color;

                      if(x === this.offer.status && x !== 10){
                          color= 'warning';
                      }

                      data.push({
                          color: color,
                          icon: iconsAndStatuses[x].icon,
                          title: this.$t("OfferTimelineShort" + x),
                          desc: this.$t("OfferTimelineLong" + x),
                          time: this.moment(this.offer.changes[x]).format('DD/MM/YYYY HH:mm')
                      });

                  }else{
                      data.push({
                          color: "dark",
                          icon: iconsAndStatuses[x].icon,
                          title: this.$t("OfferTimelineShort" + x),
                          desc: this.$t("OfferTimelineLong" + x),
                          time: "-"
                      });
                  }

              }

              return data;


          }
        },
        methods: {
            updateOffer() {
                const thisIns = this;
                this.$http.get('/api/v1/offer/' + this.$route.params.id)
                    .then(function (response) {
                        thisIns.offer = response.data;
                        thisIns.rawOffer = JSON.stringify(response.data);
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            saveOffer() {
                const thisIns = this;
                this.$http.put('/api/v1/offer/' + this.$route.params.id, {
                    name: this.offer.name,
                    description: this.offer.description
                })
                    .then(function () {
                        thisIns.updateOffer();
                        thisIns.$vs.notify({
                            title:'Success',
                            text: "Saved",
                            color:'success',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            saveCommercialNotes() {
                const thisIns = this;
                this.$http.put('/api/v1/offer/' + this.$route.params.id + "/commercial_notes", {
                    notes: this.offer.commercial_notes
                })
                    .then(function () {
                        thisIns.updateOffer();
                        thisIns.commercialNoteEditingActive = false;
                        thisIns.$vs.notify({
                            title:'Success',
                            text: "Saved",
                            color:'success',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            moveOfferToNextStage(id){

                const thisIns = this;

                let url = '';

                switch (id) {
                    case 0: url = '/back_to_offers'; break;
                    case 1: url = '/change_needed'; break;
                    case 2: url = '/ready'; break;
                    case 3: url = '/take'; break;
                    case 4: url = '/start'; break;
                    case 5: url = '/finish/' + this.selectedOfferType; break;
                    case 6: url = '/send_to_client'; break;
                    case 7: url = '/approve'; break;
                    case 8: url = '/ordered'; break;
                    case 9: url = '/create'; break;
                    case 10: url = '/decline'; break;
                    case 11: url = '/stop'; break; //Change needed from commercialist

                }

                this.$http.post('/api/v1/offer/' + this.$route.params.id + url)
                    .then(function () {
                        thisIns.updateOffer();
                        if(id === 5){
                            thisIns.selectOfferTypePrompt = false;
                        }
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });


            },
            saveAsTemplate(){
                const thisIns = this;
                this.$http.post('/api/v1/offer/' + this.$route.params.id + "/template", {
                    title: this.saveAsTemplateTitle,
                }).then(function () {
                    thisIns.saveOfferAsTemplatePrompt = false;
                    thisIns.saveAsTemplateTitle = '';
                    thisIns.$vs.notify({
                        title:'Saved',
                        text: "Template was created",
                        color:'success',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                }).catch(function (error) {
                    thisIns.saveOfferAsTemplatePrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            }
        },
        created() {
            this.updateOffer();
        }
    }

</script>
<style lang="scss">
    #page-user-view {
        table {
            td {
                vertical-align: top;
                min-width: 140px;
                padding-bottom: .8rem;
                word-break: break-all;
            }

            &:not(.permissions-table) {
                td {
                    @media screen and (max-width:370px) {
                        display: block;
                    }
                }
            }
        }
    }

    @media screen and (min-width:1201px) and (max-width:1211px),
    only screen and (min-width:636px) and (max-width:991px) {
        #account-info-col-1 {
            width: calc(100% - 12rem) !important;
        }

    }
</style>
